import React from "react";
import { Row, Col, FormGroup } from "react-bootstrap";
import InputError from "app/Components/_form/InputError/InputError";
import SimpleSelect from "app/Components/SearchableSelect/SimpleSelect";
import Label from "app/Components/_form/Label/Label";
import DatePicker from "app/Components/DateTimeCustom/CustomDateTime";
import {
  startDateValidation,
  endDateValidation,
  disableFutureDate,
} from "app/_helpers/dateHelper";
import { employeeFormLabel } from "../Constant";
import { siteTypeList } from "app/_pages/_globalConfiguration/HealthSafetyEnvironment/Sites/Sites";

function EmployeeSiteHistoryForm({ form = {}, onChange, error = {}, siteList }) {
  return (
    // <Row>
    //   <Col md={4}>
    //     <FormGroup>
    //       <Label>Site </Label>

    //       <SimpleSelect
    //         name={"siteId"}
    //         value={form?.siteId}
    //         onChange={onChange}
    //         options={siteList}
    //         label={"name"}
    //         id="id"
    //         placeHolder={"Site"}
    //         error={error["siteId"]}
    //         menuPortalTarget={null}
    //       />
    //       <InputError error={error["siteId"]} />
    //     </FormGroup>
    //   </Col>

    //   <Col md={4}>
    //     <FormGroup>
    //       <Label>Start Date</Label>

    //       <DatePicker
    //         name={"startDate"}
    //         value={form?.startDate}
    //         onChangeDate={onChange}
    //         label={"Start Date"}
    //         placeHolder={"Start Date"}
    //         error={error["startDate"]}
    //         isValidDate={(current) => startDateValidation(current, form?.endDate)}
    //       />
    //       <InputError error={error["startDate"]} />
    //     </FormGroup>
    //   </Col>

    //   {/* <Col md={4}>
    //     <FormGroup>
    //       <Label>End Date</Label>

    //       <DatePicker
    //         name={"endDate"}
    //         value={form?.endDate}
    //         onChangeDate={onChange}
    //         label={"End Date"}
    //         placeHolder={"End Date"}
    //         error={error["endDate"]}
    //         isValidDate={(current) => endDateValidation(current, form?.startDate)}
    //       />
    //       <InputError error={error["endDate"]} />
    //     </FormGroup>
    //   </Col> */}
    // </Row>
    <Row>
      <Col md={6}>
        <FormGroup>
          <Label>{employeeFormLabel["siteType"]}</Label>

          <SimpleSelect
            name={"siteType"}
            value={form?.siteType}
            onChange={onChange}
            options={siteTypeList}
            label={"name"}
            id="value"
            placeHolder={employeeFormLabel["siteType"]}
            error={error["siteType"]}
            menuPortalTarget={null}
          />
          <InputError error={error["siteType"]} />
        </FormGroup>
      </Col>
      <Col md={6}>
        <FormGroup>
          <Label>{employeeFormLabel["currentWorkLocation"]}</Label>

          <SimpleSelect
            name={"currentWorkLocation"}
            value={form?.currentWorkLocation}
            onChange={onChange}
            options={
              form?.siteType
                ? siteList
                    .filter((d) => d.siteType === +form?.siteType)
                    .map((d) => ({
                      name: `${d.name}`,
                      value: d.id,
                    }))
                : []
            }
            label={"name"}
            disabled={!form?.siteType}
            id="value"
            placeHolder={employeeFormLabel["currentWorkLocation"]}
            error={error["currentWorkLocation"]}
            menuPortalTarget={null}
          />
          <InputError error={error["currentWorkLocation"]} />
        </FormGroup>
      </Col>
      <Col md={6}>
        <FormGroup>
          <Label>{employeeFormLabel["startDateAtMines"]}</Label>

          <DatePicker
            name={"startDateAtMines"}
            value={form?.startDateAtMines}
            onChangeDate={onChange}
            label={employeeFormLabel["startDateAtMines"]}
            placeHolder={employeeFormLabel["startDateAtMines"]}
            error={error["startDateAtMines"]}
            disabled={!form?.siteType}
            isValidDate={disableFutureDate}
          />
          <InputError error={error["startDateAtMines"]} />
        </FormGroup>
      </Col>

      <Col md={2}>
        <FormGroup>
          <Label>{employeeFormLabel["mineTag"]}</Label>

          {/* <FormCheckbox
                    type="checkbox"
                    // name="permanentDisability"
                    checked={form?.mineTag === "yes"}
                    disabled
                    // onChange={onChange}
                    // label={"Fatality/permanent loss of body part or permanent disability"}
                  /> */}
          <span>{form?.mineTag === "yes" ? "YES" : "NO"}</span>
          <InputError error={error["mineTag"]} />
        </FormGroup>
      </Col>
    </Row>
  );
}

export default EmployeeSiteHistoryForm;
